var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "ArchiveComponent" } },
    [
      !_vm.hideFilters
        ? _c(
            "b-row",
            [
              _c(
                "b-col",
                { staticClass: "pl-3" },
                [
                  _c(
                    "b-form-group",
                    {
                      staticClass: "custom-input mb-0",
                      attrs: {
                        id: "start-date-input-group",
                        label: _vm.$t("message.first"),
                        "label-for": "start-date-input",
                        "label-sr-only": "",
                      },
                    },
                    [
                      _c("datetime", {
                        attrs: {
                          "max-datetime": _vm.maxDate,
                          "min-datetime": _vm.lastFiveYear,
                          phrases: _vm.phrases,
                          placeholder: _vm.$t("message.startDate"),
                          auto: "",
                          "input-class": "form-control rounded-0",
                          "input-id": "start-date-input",
                          type: "datetime",
                        },
                        model: {
                          value: _vm.startDate,
                          callback: function ($$v) {
                            _vm.startDate = $$v
                          },
                          expression: "startDate",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "pl-3" },
                [
                  _c(
                    "b-form-group",
                    {
                      staticClass: "custom-input mb-0",
                      attrs: {
                        id: "end-date-input-group",
                        label: _vm.$t("message.last"),
                        "label-for": "end-date-input",
                        "label-sr-only": "",
                      },
                    },
                    [
                      _c("datetime", {
                        attrs: {
                          "max-datetime": _vm.maxDate,
                          "min-datetime": _vm.lastFiveYear,
                          phrases: _vm.phrases,
                          placeholder: _vm.$t("message.endDate"),
                          auto: "",
                          "input-class": "form-control rounded-0",
                          "input-id": "end-date-input",
                          type: "datetime",
                        },
                        model: {
                          value: _vm.endDate,
                          callback: function ($$v) {
                            _vm.endDate = $$v
                          },
                          expression: "endDate",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "pl-3" },
                [
                  _c(
                    "b-form-group",
                    {
                      staticClass: "custom-input mb-0",
                      attrs: {
                        id: "query-input-group",
                        label: _vm.$t("message.query"),
                        "label-for": "query-input",
                        "label-sr-only": "",
                      },
                    },
                    [
                      _c("b-form-input", {
                        attrs: {
                          id: "query-input",
                          placeholder: _vm.$t("message.query"),
                          name: "query",
                        },
                        model: {
                          value: _vm.query,
                          callback: function ($$v) {
                            _vm.query = $$v
                          },
                          expression: "query",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "pl-3" },
                [
                  _c(
                    "b-form-group",
                    {
                      staticClass: "custom-input mb-0",
                      attrs: {
                        id: "query-input-group2",
                        label: _vm.$t("message.query"),
                        "label-for": "query-input",
                        "label-sr-only": "",
                      },
                    },
                    [
                      _c(
                        "b-form-select",
                        {
                          staticClass: "mb-3",
                          model: {
                            value: _vm.selectedUser,
                            callback: function ($$v) {
                              _vm.selectedUser = $$v
                            },
                            expression: "selectedUser",
                          },
                        },
                        [
                          _c("option", { domProps: { value: null } }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.$t("message.allUsers")) +
                                "\n                    "
                            ),
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.usersFilter.data, function (item) {
                            return _c(
                              "option",
                              { key: item._id, domProps: { value: item._id } },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(item.name) +
                                    "\n                    "
                                ),
                              ]
                            )
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("b-col", { staticClass: "pl-3" }, [
                _c(
                  "div",
                  { staticClass: "custom-input" },
                  [
                    _c("a-rate", {
                      attrs: { "allow-clear": true },
                      model: {
                        value: _vm.point,
                        callback: function ($$v) {
                          _vm.point = $$v
                        },
                        expression: "point",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mb-3" },
        [
          _c(
            "b-col",
            { class: { "col-5": !_vm.wideScreen, "col-4": _vm.wideScreen } },
            [
              _c(
                "div",
                {
                  staticClass: "scrollable",
                  attrs: { id: "conversation-list" },
                  on: { scroll: _vm.handleScroll },
                },
                [
                  _c(
                    "b-table",
                    {
                      attrs: {
                        id: "visitor-list-table",
                        fields: _vm.fields,
                        items: _vm.tableData,
                        "tbody-tr-class": _vm.rowClass,
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "cell(actions)",
                          fn: function (data) {
                            return [
                              _c(
                                "div",
                                {
                                  staticClass: "info",
                                  on: {
                                    click: function ($event) {
                                      return _vm.view(data.item._id)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "custom-card userInfo" },
                                    [
                                      _c("b", [
                                        _vm._v(_vm._s(data.item.fullname)),
                                      ]),
                                      _vm._v(" "),
                                      _c("b", [
                                        _vm._v(_vm._s(data.item.email)),
                                      ]),
                                      _vm._v(" "),
                                      _c("b", [
                                        _vm._v(
                                          _vm._s(
                                            data.item.user
                                              ? data.item.user.name
                                              : "-"
                                          )
                                        ),
                                      ]),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "custom-card back chatMeta",
                                    },
                                    [
                                      _c("b", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("date")(
                                              data.item.createdDate,
                                              "D/M/YY HH:m:s"
                                            )
                                          )
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "b",
                                        [
                                          _c("a-rate", {
                                            attrs: {
                                              "default-value":
                                                data.item.point || 0,
                                              disabled: "",
                                              size: "12",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ]),
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "text-center text-danger my-2",
                          attrs: { slot: "table-busy" },
                          slot: "table-busy",
                        },
                        [_c("b-spinner", { staticClass: "align-middle" })],
                        1
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.isBusy
                    ? _c(
                        "div",
                        { staticClass: "text-center text-info my-3" },
                        [_c("b-spinner", { staticClass: "align-middle" })],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.tableData.length
                    ? _c("div", { staticClass: "text-center text-info my-3" }, [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$t("message.chatNotFound")) +
                            "\n                "
                        ),
                      ])
                    : _vm._e(),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "b-col",
            {
              staticClass: "pl-3",
              class: { "col-7": !_vm.wideScreen, "col-5": _vm.wideScreen },
            },
            [
              _c(
                "div",
                {
                  staticClass: "scrollable",
                  staticStyle: { overflow: "hidden" },
                },
                [
                  _vm.selectedHistory.id && !_vm.wideScreen
                    ? _c(
                        "div",
                        { staticClass: "userMetaInfo bg-white" },
                        [
                          _c("b-col", { staticStyle: { margin: "10px" } }, [
                            _c("div", { staticClass: "userInfo" }, [
                              _c("div", { staticClass: "userInfo first" }, [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(_vm.$t("message.fullName")) +
                                    "\n                            "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "userInfo sec" }, [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm.selectedHistory.conversation.fullname
                                    ) +
                                    "\n                            "
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "userInfo" }, [
                              _c("div", { staticClass: "userInfo first" }, [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(_vm.$t("message.email")) +
                                    "\n                            "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "userInfo sec" }, [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm.selectedHistory.conversation.email
                                    ) +
                                    "\n                            "
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "userInfo" }, [
                              _c("div", { staticClass: "userInfo first" }, [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(_vm.$t("message.subject")) +
                                    "\n                            "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "userInfo sec" }, [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm.getTicketSubject(_vm.selectedHistory)
                                    ) +
                                    "\n                            "
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "userInfo" }, [
                              _c("div", { staticClass: "userInfo first" }, [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(_vm.$t("message.representative")) +
                                    "\n                            "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "userInfo sec" }, [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm.$_.get(
                                        _vm.selectedHistory,
                                        "conversation.user.name",
                                        ""
                                      ) || ""
                                    ) +
                                    "\n                            "
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "d-flex" }, [
                              _c("div", { staticClass: "userInfo" }, [
                                _c("div", { staticClass: "userInfo first" }, [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(_vm.$t("message.country")) +
                                      "\n                                "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "userInfo sec" }, [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(
                                        _vm.$_.get(
                                          _vm.selectedHistory,
                                          "conversation.visitor.country",
                                          "N/A"
                                        ) || "N/A"
                                      ) +
                                      "\n                                "
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "userInfo pl-3" }, [
                                _c("div", { staticClass: "userInfo first" }, [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(_vm.$t("message.language")) +
                                      "\n                                "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "userInfo sec" }, [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(
                                        _vm.selectedHistory.conversation
                                          .languageCode
                                      ) +
                                      "\n                                "
                                  ),
                                ]),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "userInfo" }, [
                              _c("div", { staticClass: "userInfo first" }, [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(_vm.$t("message.osAndBrowser")) +
                                    "\n                            "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "userInfo sec" }, [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm.$_.get(
                                        _vm.selectedHistory,
                                        "conversation.visitor.os",
                                        "N/A"
                                      ) || "N/A"
                                    ) +
                                    "\n                                " +
                                    _vm._s(
                                      _vm.$_.get(
                                        _vm.selectedHistory,
                                        "conversation.visitor.browser",
                                        "N/A"
                                      ) || "N/A"
                                    ) +
                                    "\n                            "
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "userInfo" }, [
                              _c("div", { staticClass: "userInfo first" }, [
                                _vm._v("IP"),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "userInfo sec" }, [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm.$_.get(
                                        _vm.selectedHistory,
                                        "conversation.visitor.ipAddress",
                                        "N/A"
                                      ) || "N/A"
                                    ) +
                                    "\n                            "
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "userInfo" }, [
                              _c("div", { staticClass: "userInfo first" }, [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(_vm.$t("message.chatId")) +
                                    "\n                            "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "userInfo sec" }, [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm.selectedHistory.conversation._id
                                    ) +
                                    "\n                            "
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "userInfo" }, [
                              _c("div", { staticClass: "userInfo first" }, [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm.$t("message.customerClientVersion")
                                    ) +
                                    "\n                            "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "userInfo sec" }, [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm.$_.get(
                                        _vm.selectedHistory,
                                        "conversation.visitor.version.versionStr"
                                      ) || "N/A"
                                    ) +
                                    "\n                            "
                                ),
                              ]),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c("b-col", [
                                _c(
                                  "h5",
                                  {
                                    staticClass:
                                      "text-center pointer text-info my-2",
                                  },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(_vm.$t("message.userInfo")) +
                                        "\n                                "
                                    ),
                                    _c(
                                      "md-icon",
                                      { staticClass: "text-info" },
                                      [_vm._v("expand_more")]
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.IsMessageInChat
                    ? _c("MessageList", {
                        attrs: {
                          "always-scroll-to-bottom": false,
                          contextMenuVisable: false,
                          colors: _vm.colors,
                          messages:
                            _vm.$_.get(
                              _vm.selectedHistory,
                              "conversation.conversation.startedWithChatBot",
                              false
                            ) || _vm.isArchive
                              ? _vm.getMessages()
                              : _vm.getOfflineMessages(
                                  this.selectedHistory.conversation
                                ),
                          participants: _vm.getParticipants(),
                          "scroll-top": true,
                          "is-whatsapp": !!_vm.$_.get(
                            _vm.selectedHistory.conversation,
                            "whatsappNumber"
                          ),
                        },
                      })
                    : _c(
                        "div",
                        {
                          staticClass:
                            "bg-light border px-3 py-1 px-3 text-center",
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.$t("message.noMessageInChat")) +
                              "\n                "
                          ),
                        ]
                      ),
                  _vm._v(" "),
                  _vm.isLoading
                    ? _c(
                        "div",
                        { staticClass: "text-center text-danger my-2" },
                        [_c("b-spinner", { staticClass: "align-middle" })],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _vm.wideScreen
            ? _c(
                "b-col",
                {
                  staticClass: "col-3 bg-white",
                  attrs: { id: "information-list2" },
                },
                [
                  _c("div", { staticClass: "headtitle" }, [
                    _vm._v(_vm._s(_vm.$t("message.userInfo"))),
                  ]),
                  _vm._v(" "),
                  _vm.selectedHistory.id
                    ? _c("div", [
                        _c("div", { staticClass: "userInfo" }, [
                          _c("div", { staticClass: "userInfo first" }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.$t("message.fullName")) +
                                "\n                    "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "userInfo sec" }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm.selectedHistory.conversation.fullname
                                ) +
                                "\n                    "
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "userInfo" }, [
                          _c("div", { staticClass: "userInfo first" }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.$t("message.email")) +
                                "\n                    "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "userInfo sec" }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.selectedHistory.conversation.email) +
                                "\n                    "
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "userInfo" }, [
                          _c("div", { staticClass: "userInfo first" }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.$t("message.phone")) +
                                "\n                    "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "userInfo sec" }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.selectedHistory.conversation.phone) +
                                "\n                    "
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "userInfo" }, [
                          _c("div", { staticClass: "userInfo first" }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.$t("message.subject")) +
                                "\n                    "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "userInfo sec" }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm.getTicketSubject(_vm.selectedHistory)
                                ) +
                                "\n                    "
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "userInfo" }, [
                          _c("div", { staticClass: "userInfo first" }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.$t("message.representative")) +
                                "\n                    "
                            ),
                          ]),
                          _vm._v(" "),
                          _vm.type == "ticket"
                            ? _c("div", { staticClass: "userInfo sec" }, [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      _vm.$_.get(
                                        _vm.selectedHistory,
                                        "conversation.assignedUser.name",
                                        ""
                                      ) || ""
                                    ) +
                                    "\n                    "
                                ),
                              ])
                            : _c("div", { staticClass: "userInfo sec" }, [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      _vm.$_.get(
                                        _vm.selectedHistory,
                                        "conversation.user.name",
                                        ""
                                      ) || ""
                                    ) +
                                    "\n                    "
                                ),
                              ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "d-flex" }, [
                          _c("div", { staticClass: "userInfo" }, [
                            _c("div", { staticClass: "userInfo first" }, [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.$t("message.country")) +
                                  "\n                        "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "userInfo sec" }, [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.$_.get(
                                      _vm.selectedHistory,
                                      "conversation.visitor.country",
                                      "N/A"
                                    ) || "N/A"
                                  ) +
                                  "\n                        "
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "userInfo pl-3" }, [
                            _c("div", { staticClass: "userInfo first" }, [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.$t("message.language")) +
                                  "\n                        "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "userInfo sec" }, [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.selectedHistory.conversation
                                      .languageCode
                                  ) +
                                  "\n                        "
                              ),
                            ]),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "userInfo" }, [
                          _c("div", { staticClass: "userInfo first" }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.$t("message.osAndBrowser")) +
                                "\n                    "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "userInfo sec" }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm.$_.get(
                                    _vm.selectedHistory,
                                    "conversation.visitor.os",
                                    "N/A"
                                  ) || "N/A"
                                ) +
                                "\n                        " +
                                _vm._s(
                                  _vm.$_.get(
                                    _vm.selectedHistory,
                                    "conversation.visitor.browser",
                                    "N/A"
                                  ) || "N/A"
                                ) +
                                "\n                    "
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "userInfo" }, [
                          _c("div", { staticClass: "userInfo first" }, [
                            _vm._v("IP"),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "userInfo sec" }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm.$_.get(
                                    _vm.selectedHistory,
                                    "conversation.visitor.ipAddress",
                                    "N/A"
                                  ) || "N/A"
                                ) +
                                "\n                    "
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "userInfo" }, [
                          _c("div", { staticClass: "userInfo first" }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.$t("message.chatId")) +
                                "\n                    "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "userInfo sec" }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.selectedHistory.conversation._id) +
                                "\n                    "
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "userInfo" }, [
                          _c("div", { staticClass: "userInfo first" }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm.$t("message.customerClientVersion")
                                ) +
                                "\n                    "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "userInfo sec" }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm.$_.get(
                                    _vm.selectedHistory,
                                    "conversation.visitor.version.versionStr"
                                  ) || "3.5.0"
                                ) +
                                "\n                    "
                            ),
                          ]),
                        ]),
                      ])
                    : _c(
                        "div",
                        {
                          staticClass:
                            "bg-light border px-3 py-1 px-3 text-center mt-3",
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.$t("message.noUserInfoFound")) +
                              "\n            "
                          ),
                        ]
                      ),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }